import React, { useState, useEffect } from 'react';
import { Select, Row, Col, Typography, DatePicker, Modal, Input, Icon } from 'antd';
import moment from "moment";


const Option = Select.Option;
const { Title } = Typography;
const H = [...Array(13).keys()]
// const M = [...Array(60).keys()]
const M = ['00','15','30','45']
const hours = H.map((x, index) => <Option key={index} value={x.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
})}>{x.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
})}</Option>)
const minutes = M.map((x, index) => <Option key={index} value={x.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
})}>{x.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
})}</Option>)
const now = moment().format('hh:mm A')
const [hr, m] = now.split(":")
const [mm, f] = m.split(" ")

const DateTimeScheduler = (props) => {
    const [hour, setHour] = useState(hr);
    const [minute, setMinute] = useState(mm);
    const [format, setFormt] = useState(f);
    const [dates, setDate] = useState(moment());
    const [visible, setVisible] = useState(false);
    const [dateTime, setDateTime] = useState("");
    const [error_msg, setError] = useState("");
    const [time_error, setTimeError] = useState("");
    const [disabled, setDisabled] = useState(true);

    const setDateTimeString = (date, h, m, f, time) => {
        // console.log(date, h, m, f, 'stststststststst')
        let t = moment(h + ':' + m + ' ' + f, 'hh:mm A').format('HH:mm')
        let [hours, minutes] = t.split(":")
        let datetime = moment(date).set({ "hour": hours, "minute": minutes, "second": 0 });
        // console.log(datetime, 'date.....',moment(datetime).format('DD-MM-YYYY hh:mm A'));
        setDateTime(moment(datetime).format('DD-MM-YYYY hh:mm A'))
        setDate(datetime)
        // let beginningTime = moment(props.created);
        // let status = beginningTime.isBefore(datetime);
        // setDisabled(status)
        // if(status){
        //     setTimeError("")
        // }else{
        //     setTimeError("Selected time is before ticket creation time!")
        // }        
        props.onChange(datetime, moment(datetime).format('DD-MM-YYYY hh:mm A'))

    }

    const onSelectHH = (value) => {
        setHour(value)
        setDateTimeString(dates, value, minute, format)
    }
    const onSelectMM = (value) => {
        setMinute(value)
        setDateTimeString(dates, hour, value, format)

    }
    const onSelectFF = (value) => {
        setFormt(value)
        setDateTimeString(dates, hour, minute, value)

    }
    const onChangeDate = (date, dateString) => {
        if (date) {
            setError("")
            setDate(date)
            setDateTimeString(date, hour, minute, format)
        } else {
            setDate()
        }

    }

    const handleOk = e => {
        if (dates) {
            setError("")
            setDateTimeString(dates, hour, minute, format)
            setVisible(false)
            if (props.onOk) {
                props.onOk(dates)
            }
        } else {
            setDate()
            setError("Please Select the date!")
        }

    };

    const handleCancel = e => {
        setVisible(false)
        setDateTime("")
        setError("")
    };
    const showModal = () => {
        if(!disabled)
            setVisible(true)
    };

    useEffect(() => {
        if(props.value!==""){
            setDateTime(moment(props.value).format('DD-MM-YYYY hh:mm A'))
        }else{
            setDateTime("")
        }
       
    }, [props.value]);

    useEffect(() => {
        setDisabled(props.disabled)
    }, [props.disabled]);

    useEffect(() => {
        if(visible){
            setDate(moment());        
            const now = moment().format('hh:mm A')
            const [hr, m] = now.split(":")
            const [mm,f] = m.split(" ")
            // console.log(hr,mm,f,'nnnnnnnnnnnnnnnnnnnnnnnnnnnnow2')
            setHour(hr)
            setMinute(mm)
            setFormt(f)
        }
        
    }, [visible]);

    // function disabledDate(current) {     
    //     return  current < moment(props.created).startOf('day');
    //   }

    // const checkDateTimeString = (date, h, m, f, time) => {
    //     let t = moment(h + ':' + m + ' ' + f, 'hh:mm A').format('HH:mm')
    //     let [hours, minutes] = t.split(":")
    //     let datetime = moment(date).set({ "hour": hours, "minute": minutes });       
    //     let beginningTime = moment(props.created);
    //     let status = beginningTime.isBefore(datetime);
    //     if(status){
    //         setTimeError("")
    //     }else{
    //         setTimeError("Selected time is before ticket creation time!")
    //     }
    //     return status
    // }

    return (
        <div>
            <Modal
                title={props.title}
                visible={visible}
                onOk={handleOk}
                onCancel={handleCancel}
                destroyOnClose={true}
                // okButtonProps={{disabled:!disabled}}
            >
                <Row>
                    <Col lg={5} md={24} sm={24} xs={24} >
                        <Title level={4} style={{ textAlign: "center" }}>HH</Title>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            placeholder="HH"
                            optionFilterProp="children"
                            onSelect={onSelectHH}
                            value={hour}
                        >
                            {hours}
                        </Select>
                    </Col>
                    <Col lg={5} md={24} sm={24} xs={24} >
                        <Title level={4} style={{ textAlign: "center" }}>MM</Title>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            placeholder="MM"
                            optionFilterProp="children"
                            onSelect={onSelectMM}
                            value={minute}

                        >
                            {minutes}
                        </Select>
                    </Col>
                    <Col lg={5} md={24} sm={24} xs={24} >
                        <Title level={4} style={{ textAlign: "center" }}>AM/PM</Title>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            placeholder="AM/PM"
                            optionFilterProp="children"
                            onSelect={onSelectFF}
                            value={format}

                        >
                            <Option value="AM">AM</Option>
                            <Option value="PM">PM</Option>

                        </Select>
                    </Col>
                    
                    <Col lg={24} md={24} sm={24} xs={24}>
                    <br></br>
                        <p style={{ color: "red" }}>{time_error}</p>
                    </Col>
                    <Col lg={24} md={24} sm={24} xs={24}>
                        <br></br>
                        <DatePicker format="DD-MM-YYYY" onChange={onChangeDate} defaultValue={moment()}  />
                        <br></br>
                        <p style={{ color: "red" }}>{error_msg}</p>
                    </Col>
                </Row>

            </Modal>
            <Row>
                <Col lg={24} md={24} sm={24} xs={24} >
                    <Input disabled={disabled} style={{minWidth:props.width}} value={dateTime} onClick={showModal} placeholder="Select Date" addonAfter={<Icon  type="calendar" onClick={showModal} />} ></Input>

                </Col>
            </Row>
        </div>
    )
}

export default DateTimeScheduler;